import React from "react";

export const Rules = (props: any) => {
  return <div></div>;
};
